import { MenuControllerId, MenuItem } from '@adaptiva/core/menus';
import { EJavaClassNames, SensorServerObject, ServerObjectMenuController } from '@adaptiva/data-service';
import { EServerOverlayIds } from '@adaptiva/server/overlays';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable()
export class SensorMenuController<T extends SensorServerObject> extends ServerObjectMenuController<T> {

	public static override readonly id: MenuControllerId.Any = `${MenuControllerId.Prefix.Default}${EJavaClassNames.SensorServerObject}`;

	public readonly resetSensorMenuName: string = 'Reset Sensors';

	public override generate(_sensor: T): Observable<MenuItem<T>[]> {
		return super.generate(_sensor).pipe(
			map((_items: MenuItem<T>[]) => {
				return _items.concat(
					this.getResetSensorMenuItem(_sensor),
				);
			})
		);
	}

	public override getClassName(): string {
		return EJavaClassNames.SensorServerObject;
	}

	protected getResetSensorMenuItem(_sensor: T): MenuItem<T> {
		const _itemId: string = this.hashItem(this.resetSensorMenuName, _sensor);
		const _item: MenuItem<T> = this.getItem(_itemId, _sensor) || this.createItem({
			id: _itemId,
			name: this.resetSensorMenuName,
			data: _sensor,
			onSelect: this.resetSensor.bind(this)
		});

		return _item;
	}

	protected resetSensor(_item: MenuItem<T>): void {
		this.overlays.load({
			overlayId: EServerOverlayIds.SENSOR_RESET_OVERLAY,
			context: { sensorIds: [_item.data.objectId] }
		}).pipe(
			this.takeOneUntilDestroyed(),
		).subscribe({
			error: (e: Error): void => {
				this.errorHandler.defaultErrorHandler(e, 'SensorMenuController.resetSensor');
			}
		});
	}

}
